import { render, staticRenderFns } from "./ProductUnit.vue?vue&type=template&id=90508010&"
import script from "./ProductUnit.vue?vue&type=script&lang=js&"
export * from "./ProductUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90508010')) {
      api.createRecord('90508010', component.options)
    } else {
      api.reload('90508010', component.options)
    }
    module.hot.accept("./ProductUnit.vue?vue&type=template&id=90508010&", function () {
      api.rerender('90508010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ProductUnit.vue"
export default component.exports